var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-info-component',{attrs:{"title":_vm.$t('pages.planning.widgets.planning_hours'),"value":_vm.value,"is-loading":_vm.isLoading}})}
var staticRenderFns = []

export { render, staticRenderFns }